import { useCallback } from 'react'
import { connect } from 'react-redux'
import { Dispatch } from '@reduxjs/toolkit'

import type { GlobalState } from '../types'
import { PreviewDisplay } from './PreviewDisplay'
import type { FileType } from './types'
import { displayInModal, toggleCategory,uploadDelete } from './upload-actions'
import { categories } from './upload-constants'
import { getSortedFiles } from './upload-selectors'

type PreviewProps = {
  sortedFiles: Record<string, FileType[]>
  hideCategories: string[]
  onDelete(fileName: string): void
  onDisplayInModal(fileName: string): void
  onToggleCategory(category: string): void
}

const PreviewComponent = (props: PreviewProps) => {
  const {
    onDelete,
    onDisplayInModal,
    hideCategories,
    sortedFiles,
    onToggleCategory
  } = props

  const handleDelete = useCallback((fileName: string) =>{
    onDelete(fileName)
  }, [onDelete])

  const handleDisplay = useCallback((fileName: string) =>{
    onDisplayInModal(fileName)
  }, [onDisplayInModal])

  const handleClose = () => onDisplayInModal('')

  const toggleCategory = (category: string) => {
    onToggleCategory(category)
  }

  categories.sort((c1, c2) => c1.rank - c2.rank)
  return (
    <PreviewDisplay
      files={sortedFiles}
      categories={categories}
      handleDelete={handleDelete}
      handleDisplay={handleDisplay}
      toggleCategory={toggleCategory}
      hideCategories={hideCategories}
      handleClose={handleClose}
    />
  )
}

const mapStateToProps = (state: GlobalState) => ({
  hideCategories: state.upload.hideCategories,
  sortedFiles: getSortedFiles(state),
})

const mapDispatchToProps = (dispatch: Dispatch) => ({
  onDelete: (fileName: string) => dispatch(uploadDelete(fileName)),
  onDisplayInModal: (fileName: string) => dispatch(displayInModal(fileName)),
  onToggleCategory: (category: string) => dispatch(toggleCategory(category))
})

const Preview = connect(mapStateToProps, mapDispatchToProps)(PreviewComponent)

export {
  Preview
}
